// Что пользователь может в выбранном парке.
//
// Источник - ответ GET /companies/selected/capabilities: role и permissions.
// permissions уже посчитаны бэкендом (шаблон роли +/- личные галочки, пересечено
// с тарифом), фронт ничего не досчитывает.
//
// user_type для этого использовать нельзя: раздел «Сотрудники» заводит каждому
// сотруднику легаси-профиль Operator, и у механика user_type === 'operator'.
// Легаси-таблица ниже нужна только пока permissions не приехали (старый бэкенд
// или сбой запроса) и для внутреннего менеджера платформы, у которого нет
// членства в парке и поэтому нет прав в парке.
//
// Коды совпадают с реестром прав бэкенда (user/rbac_definitions.py).
const LEGACY_PERMISSIONS = {
  operator: ['courier_invite', 'invitation_list', 'telegram_linked_chat', 'telegram_bot_link'],
  manager: ['operator_invite', 'invitation_list'],
}

// Управление сотрудниками закрыто суперадмину на запись, показывать ему
// раздел незачем
const NEVER_FOR_SUPERUSER = ['staff_manage']

export const buildAccess = (currentUser, capabilities) => {
  const isSuperuser = Boolean(currentUser?.is_superuser)
  const isInternalManager = currentUser?.user_type === 'manager'
  const role = capabilities?.role || null
  const received = Array.isArray(capabilities?.permissions) ? capabilities.permissions : null

  // Пустой список у суперадмина и внутреннего менеджера - не «доступ отключён»,
  // а отсутствие членства: они смотрят платформу целиком
  const platformUser = isSuperuser || isInternalManager
  const permissions = received && received.length === 0 && platformUser ? null : received

  const legacy = LEGACY_PERMISSIONS[currentUser?.user_type] || []
  const legacyAll = isSuperuser ? [...legacy, ...LEGACY_PERMISSIONS.manager] : legacy

  // Строгая проверка: действие доступно, только если право подтверждено
  const can = (code) => {
    if (isSuperuser && !NEVER_FOR_SUPERUSER.includes(code)) {
      return permissions ? true : legacyAll.includes(code)
    }
    return permissions ? permissions.includes(code) : legacyAll.includes(code)
  }

  // Мягкая проверка для разделов меню: пока права не приехали, показываем всё.
  // Спрятать лишнее не страшно, оно закрыто на бэкенде, а пустое меню из-за
  // сетевого сбоя выглядит как сломанная система
  const canSee = (code) => {
    if (!code) return true
    if (permissions === null) return true
    return can(code)
  }

  // Человек есть, а доступа в выбранном парке нет: сотрудника отключили или
  // выбранный парк больше не его. Это отдельное состояние, а не пустой интерфейс
  const isAccessDisabled = Boolean(capabilities?.isLoaded) && received !== null && !role && !platformUser

  return { can, canSee, role, isAccessDisabled }
}
